import React from 'react';
import { COLORS } from '../../../../utils/constants';
import { ChevronDown, ChevronRight, Edit2, Trash2 } from 'lucide-react';
import { getRoleColor } from './TeamUIComponents';

const SubordinateAdminsList = ({ 
  admins, 
  depth = 1, 
  expandedAdmins, 
  toggleAdminExpand,
  isSuperAdmin, 
  setEditingMember, 
  setDeletingMember 
}) => {
  const paddingLeft = 40 + (depth * 20);
  const bgOpacity = Math.max(0.02, 0.08 - (depth * 0.02));
  
  const getTotalClients = (admin) => {
    let total = admin.client_count || 0;
    total += (admin.managers || []).reduce((s, m) => s + (m.client_count || 0), 0);
    (admin.subordinate_admins || []).forEach(sa => {
      total += getTotalClients(sa);
    });
    return total;
  };
  
  return (
    <div style={{ 
      borderTop: `1px solid ${COLORS.border}`, 
      backgroundColor: `rgba(139, 92, 246, ${bgOpacity})` 
    }}>
      <div style={{ 
        padding: `8px 20px 4px ${paddingLeft}px`, 
        fontSize: '11px', 
        color: COLORS.textSecondary, 
        fontWeight: '600' 
      }}>
        {depth === 1 ? 'ПОДЧИНЁННЫЕ АДМИНЫ' : `УРОВЕНЬ ${depth}`}
      </div>
      
      {admins.map(admin => (
        <div key={admin.id}>
          <div
            onClick={() => toggleAdminExpand(admin.id)}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: `12px 20px 12px ${paddingLeft}px`,
              borderBottom: `1px solid ${COLORS.border}20`,
              cursor: (admin.managers?.length > 0 || admin.subordinate_admins?.length > 0) ? 'pointer' : 'default'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              {(admin.managers?.length > 0 || admin.subordinate_admins?.length > 0) ? (
                expandedAdmins[admin.id] ? 
                  <ChevronDown size={16} color={COLORS.textSecondary} /> : 
                  <ChevronRight size={16} color={COLORS.textSecondary} />
              ) : <div style={{ width: 16 }} />}
              
              <div style={{
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                backgroundColor: `${getRoleColor('admin')}20`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: getRoleColor('admin'),
                fontWeight: '600',
                fontSize: '14px',
                border: `2px solid ${getRoleColor('admin')}40`
              }}>
                {admin.name?.charAt(0).toUpperCase() || 'A'}
              </div>
              
              <div>
                <div style={{ color: COLORS.text, fontSize: '14px', fontWeight: '600' }}>
                  {admin.name || admin.email}
                  <span style={{ 
                    marginLeft: '8px',
                    padding: '2px 6px',
                    backgroundColor: `${getRoleColor('admin')}20`,
                    color: getRoleColor('admin'),
                    borderRadius: '4px',
                    fontSize: '10px',
                    fontWeight: '700'
                  }}>АДМИН L{depth}</span>
                </div>
                <div style={{ color: COLORS.textSecondary, fontSize: '11px' }}>
                  {admin.email} • {admin.managers?.length || 0} менедж. • {admin.subordinate_admins?.length || 0} подч. админ.
                </div>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              {admin.subordinate_admins?.length > 0 && (
                <div style={{ textAlign: 'center' }}>
                  <div style={{ color: '#8b5cf6', fontSize: '14px', fontWeight: '700' }}>
                    {admin.subordinate_admins.length}
                  </div>
                  <div style={{ color: COLORS.textSecondary, fontSize: '9px' }}>подч. адм.</div>
                </div>
              )}
              <div style={{ textAlign: 'center' }}>
                <div style={{ color: '#3b82f6', fontSize: '14px', fontWeight: '700' }}>
                  {admin.manager_count || admin.managers?.length || 0}
                </div>
                <div style={{ color: COLORS.textSecondary, fontSize: '9px' }}>менедж.</div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ color: '#10b981', fontSize: '14px', fontWeight: '700' }}>
                  {admin.client_count || getTotalClients(admin)}
                </div>
                <div style={{ color: COLORS.textSecondary, fontSize: '9px' }}>в сети</div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ color: COLORS.text, fontSize: '14px', fontWeight: '700' }}>
                  {admin.direct_client_count || 0}
                </div>
                <div style={{ color: COLORS.textSecondary, fontSize: '9px' }}>своих</div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ color: COLORS.text, fontSize: '14px', fontWeight: '700' }}>
                  {admin.clients_on_managers || 0}
                </div>
                <div style={{ color: COLORS.textSecondary, fontSize: '9px' }}>на мен.</div>
              </div>
              
              {isSuperAdmin && (
                <div style={{ display: 'flex', gap: '6px' }} onClick={e => e.stopPropagation()}>
                  <button
                    onClick={() => setEditingMember(admin)}
                    style={{
                      padding: '6px',
                      backgroundColor: COLORS.background,
                      border: `1px solid ${COLORS.border}`,
                      borderRadius: '6px',
                      color: COLORS.textSecondary,
                      cursor: 'pointer'
                    }}
                  >
                    <Edit2 size={12} />
                  </button>
                  <button
                    onClick={() => setDeletingMember(admin)}
                    style={{
                      padding: '6px',
                      backgroundColor: `${COLORS.danger}15`,
                      border: `1px solid ${COLORS.danger}40`,
                      borderRadius: '6px',
                      color: COLORS.danger,
                      cursor: 'pointer'
                    }}
                  >
                    <Trash2 size={12} />
                  </button>
                </div>
              )}
            </div>
          </div>
          
          {expandedAdmins[admin.id] && admin.managers?.length > 0 && (
            <div style={{ backgroundColor: `rgba(59, 130, 246, 0.05)` }}>
              {admin.managers.map(manager => (
                <div
                  key={manager.id}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: `10px 20px 10px ${paddingLeft + 30}px`,
                    borderBottom: `1px solid ${COLORS.border}15`
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={{
                      width: '30px',
                      height: '30px',
                      borderRadius: '50%',
                      backgroundColor: `${getRoleColor('manager')}20`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: getRoleColor('manager'),
                      fontWeight: '600',
                      fontSize: '12px'
                    }}>
                      {manager.name?.charAt(0).toUpperCase() || 'M'}
                    </div>
                    <div>
                      <div style={{ color: COLORS.text, fontSize: '13px', fontWeight: '500' }}>
                        {manager.name || manager.email}
                      </div>
                      <div style={{ color: COLORS.textSecondary, fontSize: '10px' }}>
                        {manager.email}
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <span style={{ color: COLORS.text, fontSize: '13px' }}>
                      {manager.client_count || 0} клиентов
                    </span>
                    {isSuperAdmin && (
                      <div style={{ display: 'flex', gap: '4px' }}>
                        <button
                          onClick={() => setEditingMember(manager)}
                          style={{
                            padding: '4px',
                            backgroundColor: COLORS.background,
                            border: `1px solid ${COLORS.border}`,
                            borderRadius: '4px',
                            color: COLORS.textSecondary,
                            cursor: 'pointer'
                          }}
                        >
                          <Edit2 size={10} />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
          
          {expandedAdmins[admin.id] && admin.subordinate_admins?.length > 0 && (
            <SubordinateAdminsList 
              admins={admin.subordinate_admins}
              depth={depth + 1}
              expandedAdmins={expandedAdmins}
              toggleAdminExpand={toggleAdminExpand}
              isSuperAdmin={isSuperAdmin}
              setEditingMember={setEditingMember}
              setDeletingMember={setDeletingMember}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default SubordinateAdminsList;
